import { useEffect, useRef } from 'react';
import { useInRouterContext, useLocation } from 'react-router-dom';
import translations from '../i18n/translations';

function useCurrentPathname() {
  const inRouter = useInRouterContext();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return inRouter ? useLocation().pathname : window.location.pathname;
}

export default function PermissionChangeDialog({ change, onConfirm }) {
  const dialogRef = useRef(null);
  const pathname = useCurrentPathname();
  const language = pathname.split('/')[1] === 'en' ? 'EN' : '日本語';
  const t = translations[language].permissionChange;

  useEffect(() => {
    const dialog = dialogRef.current;
    const previousFocus = document.activeElement;
    dialog.showModal?.();
    return () => {
      dialog.close?.();
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, []);

  return (
    <dialog
      ref={dialogRef}
      aria-labelledby="permission-change-title"
      aria-describedby="permission-change-description"
      aria-modal="true"
      onCancel={(event) => event.preventDefault()}
      className="w-full max-w-md rounded-lg border border-light-border bg-light-bg p-6 text-light-text shadow-xl backdrop:bg-black/60 dark:border-glass dark:bg-main dark:text-primary"
    >
      <h2 id="permission-change-title" className="mb-4 text-lg font-bold">
        {t.title}
      </h2>
      <p id="permission-change-description" className="mb-6">
        {t.message(change.previousRole.toUpperCase(), change.currentRole.toUpperCase())}
      </p>
      <button
        type="button"
        autoFocus
        onClick={onConfirm}
        className="w-full rounded-lg bg-thinking-primary px-4 py-2 font-medium text-accent-text focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        {t.confirm}
      </button>
    </dialog>
  );
}
